import { path } from 'ramda'
import { PositionTemplate } from './positionTemplates'
import api from 'api'

export type PositionTemplateWithRequirements = Required<
  Pick<PositionTemplate, 'requirements'>
> &
  Omit<PositionTemplate, 'requirements'>

export async function getPositionTemplate(positionTemplateId?: number) {
  const data = await api.post(
    '/admin/graphql_dispatch/position_template_e01a199b',
    {
      positionTemplateId,
    }
  )

  const template = path(
    ['data', 'data', 'admin', 'positionTemplates', 0],
    data
  ) as PositionTemplateWithRequirements

  return template
    ? {
        ...template,
        id: Number(template.id),
      }
    : undefined
}

export function updatePositionPositionTemplate({
  positionId,
  positionTemplateId,
}: {
  positionId: number
  positionTemplateId: number
}) {
  return api.put(`/admin/positions/${positionId}`, {
    position_template_id: positionTemplateId,
  })
}
